import React, { memo } from 'react';
import PropTypes from 'prop-types';

export default memo(StaticTextWidget);

function StaticTextWidget({ data: { links, staticText } }) {
  return (
    <div className="container-fluid nine-tenth-text">
      <div className="row my-2">
        <p className="col-12 mb-0" style={{ whiteSpace: 'pre-line' }}>
          {staticText}
        </p>
      </div>
      {links?.map?.(({ display, url }, i) => (
        <div className="row" key={`${display}-${i}`}>
          <div className="col-12">
            <a
              className="btn btn-link p-0 nine-tenth-text"
              href={url}
              rel="noopener noreferrer"
              target="_blank"
            >
              {display}
            </a>
          </div>
        </div>
      )) || null}
    </div>
  );
}

StaticTextWidget.propTypes = {
  data: PropTypes.shape({
    links: PropTypes.arrayOf(
      PropTypes.shape({
        display: PropTypes.string,
        url: PropTypes.string,
      })
    ),
    staticText: PropTypes.string,
  }),
};
